import { Chart1, ClipboardClose, Login, SearchZoomIn } from 'iconsax-react';
import './Nav.scss';
import { Tooltip, Whisper } from 'rsuite';
import { useNewFilterList } from '../../../hooks/useNewFilterList';
import { useDispatch, useSelector } from 'react-redux';
import { Types as BulkactionTypes } from '../../../store/ducks/collectionsBulkaction';
import RecordSvg from '../../../assets/svgs/record.svg';
import TickCircleSvg from '../../../assets/svgs/tick-circle.svg';
import InfoCicleSvg from '../../../assets/svgs/info-circle2.svg';
import { toast } from 'react-toastify';

export const BaseNav = ({
  navItems,
  activeTab,
  handleChange,
  resultPage,
  colapse,
  toggleFilterList,
  results,
}) => {
  const methodsHook = useNewFilterList();
  const dispatch = useDispatch();
  const selectedCards = useSelector(
    (state) => state.collectionsBulkaction.selectedCards,
  );

  const selectedAll = () => {
    if (selectedCards.length >= 120 && results) {
      results.map((card) => {
        dispatch({ type: BulkactionTypes.UNSELECT_CARDS, cards: [card] });
      });
      return;
    }
    if (results.length > 120 && results) {
      results.slice(0, 120).map((card) => {
        if (!selectedCards.some((selectedCard) => selectedCard.id === card.id))
          dispatch({ type: BulkactionTypes.SELECT_CARDS, cards: [card] });
      });
      toast.warning(
        <span className="text-base leading-7 text-[#475467]">
          O limite de decisões selecionadas foi atingido. As primeiras 120
          decisões foram selecionadas.
        </span>,
        {
          icon: <ClipboardClose size="sm" color="#F79009" />,
        },
      );
    } else
      results &&
        results.map((card) => {
          if (
            !selectedCards.some((selectedCard) => selectedCard.id === card.id)
          )
            dispatch({ type: BulkactionTypes.SELECT_CARDS, cards: [card] });
          else if (results.length == selectedCards.length)
            dispatch({ type: BulkactionTypes.UNSELECT_CARDS, cards: [card] });
        });
  };

  return (
    <div className="tv-nav">
      <ul className={`tv-nav_tabs ${colapse ? 'tv-nav_tabs--collapsed' : ''}`}>
        {navItems.map((item, index) => {
          const isActive = activeTab === item.id;
          const textPesquisa = 'Veja a jurimetria desse tema';
          const textJurimetria = 'Veja as decisões referentes a esse tema';
          return (
            <Whisper
              key={item.id}
              speaker={
                <Tooltip>{index === 0 ? textJurimetria : textPesquisa}</Tooltip>
              }
            >
              <li
                className={`tv-nav_tabs-items${isActive ? ' tv-nav_tabs-items-active' : ''} ${
                  resultPage ? ' resultspagesize' : ''
                }`}
                {...(item['data-testid'] && {
                  'data-testid': item['data-testid'],
                })}
              >
                <a onClick={() => handleChange(item.id)} className="box-item">
                  {index === 0 && (
                    <SearchZoomIn
                      size="18"
                      color={isActive ? '#101828' : '#667085'}
                    />
                  )}
                  {index === 1 && (
                    <Chart1
                      size="18"
                      color={isActive ? '#101828' : '#667085'}
                    />
                  )}
                  {item.title}
                </a>
              </li>
            </Whisper>
          );
        })}
      </ul>
    </div>
  );
};

export const Nav = ({
  navItems,
  activeTab,
  handleChange,
  resultPage,
  colapse,
  toggleFilterList,
  results,
}) => {
  const methodsHook = useNewFilterList();
  const dispatch = useDispatch();
  const selectedCards = useSelector(
    (state) => state.collectionsBulkaction.selectedCards,
  );

  const selectedAll = () => {
    if (selectedCards.length >= 120 && results) {
      results.map((card) => {
        dispatch({ type: BulkactionTypes.UNSELECT_CARDS, cards: [card] });
      });
      return;
    }
    if (results.length > 120 && results) {
      results.slice(0, 120).map((card) => {
        if (!selectedCards.some((selectedCard) => selectedCard.id === card.id))
          dispatch({ type: BulkactionTypes.SELECT_CARDS, cards: [card] });
      });
      toast.warning(
        <span className="text-base leading-7 text-[#475467]">
          O limite de decisões selecionadas foi atingido. As primeiras 120
          decisões foram selecionadas.
        </span>,
        {
          icon: <ClipboardClose size="sm" color="#F79009" />,
        },
      );
    } else
      results &&
        results.map((card) => {
          if (
            !selectedCards.some((selectedCard) => selectedCard.id === card.id)
          )
            dispatch({ type: BulkactionTypes.SELECT_CARDS, cards: [card] });
          else if (results.length == selectedCards.length)
            dispatch({ type: BulkactionTypes.UNSELECT_CARDS, cards: [card] });
        });
  };

  return (
    <div className="tv-nav">
      {!colapse && (
        <div
          className="flex gap-1 font-bold cursor-pointer ml-8"
          onClick={toggleFilterList}
        >
          <div
            className="filter-title mt-1 font-bold"
            style={{ fontSize: '16px' }}
          >
            Filtros
          </div>

          <Whisper
            placement="top"
            trigger="hover"
            speaker={<Tooltip>Abrir filtro</Tooltip>}
          >
            <div className="filter-icon mt-1">
              <Login size="25" color="#101828" />
            </div>
          </Whisper>
        </div>
      )}
      <ul className={`tv-nav_tabs ${colapse ? 'tv-nav_tabs--collapsed' : ''}`}>
        {navItems.map((item, index) => {
          const isActive = activeTab === item.id;
          const textPesquisa = 'Veja a jurimetria desse tema';
          const textJurimetria = 'Veja as decisões referentes a esse tema';
          return (
            <Whisper
              key={item.id}
              speaker={
                <Tooltip>{index === 0 ? textJurimetria : textPesquisa}</Tooltip>
              }
            >
              <li
                className={`tv-nav_tabs-items${isActive ? ' tv-nav_tabs-items-active' : ''} ${
                  resultPage ? ' resultspagesize' : ''
                }`}
                {...(item['data-testid'] && {
                  'data-testid': item['data-testid'],
                })}
              >
                <a onClick={() => handleChange(item.id)} className="box-item">
                  {index === 0 && (
                    <SearchZoomIn
                      size="18"
                      color={isActive ? '#101828' : '#667085'}
                    />
                  )}
                  {index === 1 && (
                    <Chart1
                      size="18"
                      color={isActive ? '#101828' : '#667085'}
                    />
                  )}
                  {item.title}
                </a>
              </li>
            </Whisper>
          );
        })}
      </ul>
      <div className="custom-checkbox" onClick={selectedAll}>
        {selectedCards.length === 0 ? (
          <span className="checkmark" />
        ) : selectedCards.length >= 120 ? (
          <img src={InfoCicleSvg} alt="info" />
        ) : selectedCards.length === results.length ? (
          <img
            src={TickCircleSvg}
            alt="tick"
            style={{ width: '16px', height: '16px' }}
          />
        ) : (
          <img
            src={RecordSvg}
            alt="record"
            style={{ width: '16px', height: '16px' }}
          />
        )}
        Selecionar tudo
      </div>
    </div>
  );
};
